import React from 'react';
import { bool } from 'prop-types';
import { useFeatureContext } from './featureContext';
import styles from './FeatureToken.module.scss';

const FeatureToken = ({ beta: betaProp, promote: promoteProp }) => {
  const featureContext = useFeatureContext();

  const beta = betaProp !== undefined ? betaProp : featureContext?.beta;
  const promote = promoteProp !== undefined ? promoteProp : featureContext?.promote;

  if (beta) {
    return <span className={styles.beta}>BETA</span>;
  }

  if (promote) {
    return <span className={styles.new}>NEW</span>;
  }

  return null;
};

FeatureToken.propTypes = {
  beta: bool,
  promote: bool,
};

export default FeatureToken;
